import { useMemo } from 'react';

import { Typography, Modal, useModalWrapperContext } from '@app-velocity/ui';

import { ErrorWithNodeData } from '@app-velocity/common';
import { useI18n } from '@app-velocity/i18n';

import { WarningWithNavigate } from '../../../../components/WarningWithNavigate';

const isSnapshotWarningsData = (
  data: unknown
): data is {
  warnings: { nodeId: string; nodeName: string }[];
} => {
  const castedData = data as {
    warnings: { nodeId: string; nodeName: string }[];
  };

  return !!castedData.warnings && Array.isArray(castedData.warnings);
};

export const SnapshotWarningsModalContent = () => {
  const { modalData, openedModalId } = useModalWrapperContext();
  const { t } = useI18n();
  const { warnings } = useMemo(() => {
    const currentModalData = modalData[openedModalId];

    if (isSnapshotWarningsData(currentModalData)) {
      return currentModalData;
    }

    return { warnings: [] };
  }, [modalData, openedModalId]);

  return (
    <Modal>
      <Modal.Header title="prototypes:snapshot_warnings" />
      <Modal.Content>
        <Typography>
          {t('prototypes:snapshot_warning_properties', {
            count: warnings.length,
          })}
        </Typography>
        <Typography>
          {t('prototypes:click_to_navigate', {
            count: warnings.length,
          })}
        </Typography>
        {warnings.map((warning, index) => (
          <WarningWithNavigate
            error={
              new ErrorWithNodeData(
                `${warning.nodeName}`,
                warning.nodeId,
                warning.nodeName
              )
            }
            key={index}
          />
        ))}
      </Modal.Content>
    </Modal>
  );
};
